import React from 'react';
import Grid from '@material-ui/core/Grid';

import Session from './Session';

export default (props) => {
  return (
    <Grid container spacing={3}>
      { props.config.map((session, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Session config={session} setCurrentTime={props.setCurrentTime} />
        </Grid>
      ))}
    </Grid>
  );
};